import React, { FC } from "react";

import { Card, CardContent, Skeleton, Stack } from "@components/base";

const QuestionnairesSkeleton: FC = () => (
  <Card>
    <CardContent>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1} justifyContent="space-between">
          <Skeleton width="30%" height={20} />
          <Skeleton width="30%" height={20} />
          <Skeleton width="30%" height={20} />
        </Stack>
        <Skeleton width="100%" height={20} />
        <Skeleton width="100%" height={20} />
        <Skeleton width="100%" height={20} />
      </Stack>
    </CardContent>
  </Card>
);

export default QuestionnairesSkeleton;
